define('lq/events/actions/download',[
    'underscore',
    'lq/events/actions/eventAction',
    'lq',
    'lq/util',
    'lq/responsive',
], function (_, EventAction, lq, util, responsive) {
    'use strict';

    function Download(eventData, eventArg) {
        EventAction.call(this, eventData, eventArg);
        this.eventData = eventData;
        return this;
    }

    EventAction.extend(Download, EventAction);

    Download.typeName = 'Download';

    Download.prototype.getBatchType = function () {
        return EventAction.DO_NOT_BATCH;
    };

    Download.prototype.execute = function (continuation) {
        var document = this.piping.parameters.getValue(this.eventData.parameter);
        
        if (document) {
            document = util.convertListOfKeyValuesToObject(document);

            var openInBrowser = this.eventData.openInBrowser;

            if (responsive.isPWA()) {
                openInBrowser = false;
            }

            var url = this.piping.url.prepare(lq.getTenantUrl('DynamicContent/DownloadFile'), { url: document.Url, filename: document.Filename, openInBrowser: openInBrowser });

            if (this.eventData.openInNewTab) {
                window.open(url + '&isDownload=false#toolbar=1');
            } else {
                window.location.href = url;
            }
        }

        continuation();
    };

    return Download;
});
